'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ''], ['', '']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  animation: ', ';\n  animation-duration: ', ';\n  animation-delay: ', ';\n  animation-iteration-count: ', ';\n  animation-play-state: ', ';\n  animation-fill-mode: ', ';\n  display: ', ';\n'], ['\n  animation: ', ';\n  animation-duration: ', ';\n  animation-delay: ', ';\n  animation-iteration-count: ', ';\n  animation-play-state: ', ';\n  animation-fill-mode: ', ';\n  display: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactAnimations = require('react-animations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chooseReactAnimation = function chooseReactAnimation(props) {
  if (props.bounceOut) return _reactAnimations.bounceOut;
  if (props.bounce) return _reactAnimations.bounce;
  if (props.bounceIn) return _reactAnimations.bounceIn;
  if (props.bounceInDown) return _reactAnimations.bounceInDown;
  if (props.bounceInLeft) return _reactAnimations.bounceInLeft;
  if (props.bounceInRight) return _reactAnimations.bounceInRight;
  if (props.bounceInUp) return _reactAnimations.bounceInUp;
  if (props.bounceOutDown) return _reactAnimations.bounceOutDown;
  if (props.bounceOutLeft) return _reactAnimations.bounceOutLeft;
  if (props.bounceOutRight) return _reactAnimations.bounceOutRight;
  if (props.bounceOutUp) return _reactAnimations.bounceOutUp;
  if (props.fadeIn) return _reactAnimations.fadeIn;
  if (props.fadeInDown) return _reactAnimations.fadeInDown;
  if (props.fadeInDownBig) return _reactAnimations.fadeInDownBig;
  if (props.fadeInLeft) return _reactAnimations.fadeInLeft;
  if (props.fadeInLeftBig) return _reactAnimations.fadeInLeftBig;
  if (props.fadeInRight) return _reactAnimations.fadeInRight;
  if (props.fadeInRightBig) return _reactAnimations.fadeInRightBig;
  if (props.fadeInUp) return _reactAnimations.fadeInUp;
  if (props.fadeInUpBig) return _reactAnimations.fadeInUpBig;
  if (props.fadeOut) return _reactAnimations.fadeOut;
  if (props.fadeOutDown) return _reactAnimations.fadeOutDown;
  if (props.fadeOutDownBig) return _reactAnimations.fadeOutDownBig;
  if (props.fadeOutLeft) return _reactAnimations.fadeOutLeft;
  if (props.fadeOutLeftBig) return _reactAnimations.fadeOutLeftBig;
  if (props.fadeOutRight) return _reactAnimations.fadeOutRight;
  if (props.fadeOutRightBig) return _reactAnimations.fadeOutRightBig;
  if (props.fadeOutUp) return _reactAnimations.fadeOutUp;
  if (props.fadeOutUpBig) return _reactAnimations.fadeOutUpBig;
  if (props.flash) return _reactAnimations.flash;
  if (props.flip) return _reactAnimations.flip;
  if (props.flipInX) return _reactAnimations.flipInX;
  if (props.flipInY) return _reactAnimations.flipInY;
  if (props.flipOutX) return _reactAnimations.flipOutX;
  if (props.flipOutY) return _reactAnimations.flipOutY;
  if (props.headShake) return _reactAnimations.headShake;
  if (props.hinge) return _reactAnimations.hinge;
  if (props.jello) return _reactAnimations.jello;
  if (props.lightSpeedIn) return _reactAnimations.lightSpeedIn;
  if (props.lightSpeedOut) return _reactAnimations.lightSpeedOut;
  if (props.pulse) return _reactAnimations.pulse;
  if (props.rollIn) return _reactAnimations.rollIn;
  if (props.rollOut) return _reactAnimations.rollOut;
  if (props.rotateIn) return _reactAnimations.rotateIn;
  if (props.rotateInDownLeft) return _reactAnimations.rotateInDownLeft;
  if (props.rotateInDownRight) return _reactAnimations.rotateInDownRight;
  if (props.rotateInUpLeft) return _reactAnimations.rotateInUpLeft;
  if (props.rotateInUpRight) return _reactAnimations.rotateInUpRight;
  if (props.rotateOut) return _reactAnimations.rotateOut;
  if (props.rotateOutDownLeft) return _reactAnimations.rotateOutDownLeft;
  if (props.rotateOutDownRight) return _reactAnimations.rotateOutDownRight;
  if (props.rotateOutUpLeft) return _reactAnimations.rotateOutUpLeft;
  if (props.rotateOutUpRight) return _reactAnimations.rotateOutUpRight;
  if (props.rubberBand) return _reactAnimations.rubberBand;
  if (props.shake) return _reactAnimations.shake;
  if (props.slideInDown) return _reactAnimations.slideInDown;
  if (props.slideInLeft) return _reactAnimations.slideInLeft;
  if (props.slideInRight) return _reactAnimations.slideInRight;
  if (props.slideInUp) return _reactAnimations.slideInUp;
  if (props.slideOutDown) return _reactAnimations.slideOutDown;
  if (props.slideOutLeft) return _reactAnimations.slideOutLeft;
  if (props.slideOutRight) return _reactAnimations.slideOutRight;
  if (props.slideOutUp) return _reactAnimations.slideOutUp;
  if (props.swing) return _reactAnimations.swing;
  if (props.tada) return _reactAnimations.tada;
  if (props.wobble) return _reactAnimations.wobble;
  if (props.zoomIn) return _reactAnimations.zoomIn;
  if (props.zoomInDown) return _reactAnimations.zoomInDown;
  if (props.zoomInLeft) return _reactAnimations.zoomInLeft;
  if (props.zoomInRight) return _reactAnimations.zoomInRight;
  if (props.zoomInUp) return _reactAnimations.zoomInUp;
  if (props.zoomOut) return _reactAnimations.zoomOut;
  if (props.zoomOutDown) return _reactAnimations.zoomOutDown;
  if (props.zoomOutLeft) return _reactAnimations.zoomOutLeft;
  if (props.zoomOutRight) return _reactAnimations.zoomOutRight;
  if (props.zoomOutUp) return _reactAnimations.zoomOutUp;
  if (props.flipInX) return _reactAnimations.flipInX;
  return _reactAnimations.bounce;
};

var animationStyle = function animationStyle(props) {
  return (0, _styledComponents.keyframes)(_templateObject, chooseReactAnimation(props));
};

var Animate = _styledComponents2.default.div(_templateObject2, animationStyle, function (props) {
  if (props.time) return props.time;
  return '1s';
}, function (props) {
  if (props.delay) return props.delay;
  return '0s';
}, function (props) {
  if (props.count) return props.count;
  return '1';
}, function (props) {
  if (props.trigger) return 'running';
  return 'paused';
}, function (props) {
  if (props.fillMode) return props.fillMode;
  return 'none';
}, function (props) {
  if (props.display) return props.display;
  return 'inherit';
});

Animate.displayName = 'Animate';

exports.default = Animate;
//# sourceMappingURL=Animate.js.map


//////////////////
// WEBPACK FOOTER
// ../animate/lib/Animate.js
// module id = 577
// module chunks = 0